module.exports = __webpack_public_path__ + "static/media/vr-logo192.f5c26584.png";